import {
  DEFAULT_APPSFLYER_WEB_POPUP_MEDIA_SOURCE,
  DEFAULT_APPSFLYER_WEB_POPUP_ONELINK_URL,
} from "./nativeAppAttributionLink";

const readEnv = (value?: string) => value?.trim() ?? "";
const browserOrigin = typeof window !== "undefined" ? window.location.origin : "";
const buildId = typeof __APP_BUILD_ID__ === "string" ? __APP_BUILD_ID__ : "dev-build";
const readBooleanEnv = (value?: string, defaultValue = false) => {
  const normalized = readEnv(value).toLowerCase();
  if (["1", "true", "yes", "on"].includes(normalized)) return true;
  if (["0", "false", "no", "off"].includes(normalized)) return false;
  return defaultValue;
};
const readNumberEnv = (value?: string, defaultValue = 0) => {
  const normalized = Number.parseFloat(readEnv(value));
  return Number.isFinite(normalized) ? normalized : defaultValue;
};

export const env = {
  appEnv: readEnv(import.meta.env.VITE_APP_ENV) || (import.meta.env.DEV ? "development" : "production"),
  appUrl: readEnv(import.meta.env.VITE_APP_URL) || browserOrigin,
  opsAppUrl: readEnv(import.meta.env.VITE_OPS_APP_URL) || "https://admin.mypetroutine.petnow.io",
  kakaoJavascriptKey: readEnv(import.meta.env.VITE_KAKAO_JAVASCRIPT_KEY),
  metaPixelId: readEnv(import.meta.env.VITE_META_PIXEL_ID),
  portoneStoreId: readEnv(import.meta.env.VITE_PORTONE_STORE_ID),
  portoneChannelKey: readEnv(import.meta.env.VITE_PORTONE_CHANNEL_KEY),
  posthogKey: readEnv(import.meta.env.VITE_POSTHOG_KEY),
  posthogHost: readEnv(import.meta.env.VITE_POSTHOG_HOST),
  appsFlyerWebPopupOneLinkUrl: readEnv(import.meta.env.VITE_APPSFLYER_WEB_POPUP_ONELINK_URL)
    || DEFAULT_APPSFLYER_WEB_POPUP_ONELINK_URL,
  appsFlyerWebPopupMediaSource: readEnv(import.meta.env.VITE_APPSFLYER_WEB_POPUP_MEDIA_SOURCE)
    || DEFAULT_APPSFLYER_WEB_POPUP_MEDIA_SOURCE,
  channelTalkPluginKey: readEnv(import.meta.env.VITE_CHANNEL_TALK_PLUGIN_KEY),
  supabaseUrl: readEnv(import.meta.env.VITE_SUPABASE_URL),
  supabaseAnonKey: readEnv(import.meta.env.VITE_SUPABASE_ANON_KEY),
  sentryDsn: readEnv(import.meta.env.VITE_SENTRY_DSN),
  sentryRelease: readEnv(import.meta.env.VITE_SENTRY_RELEASE) || buildId,
  sentryTracesSampleRate: readNumberEnv(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE, 0.01),
  betaFreeMode: readBooleanEnv(import.meta.env.VITE_BETA_FREE_MODE, false),
  phaseOneKrWebCatalogReady: readBooleanEnv(import.meta.env.VITE_PHASE_ONE_KR_WEB_CATALOG_READY, false),
};

export const isMetaPixelConfigured = Boolean(env.metaPixelId);
export const isPosthogConfigured = Boolean(env.posthogKey && env.posthogHost);
export const isSupabaseConfigured = Boolean(env.supabaseUrl && env.supabaseAnonKey);
export const isSentryConfigured = Boolean(env.sentryDsn);
export const isPortOneBillingConfigured = Boolean(env.portoneStoreId && env.portoneChannelKey);
export const isBillingUiEnabled = readBooleanEnv(import.meta.env.VITE_BILLING_PHASE1_UI_ENABLED, false);
